module.exports = __webpack_public_path__ + "static/media/nature_weather-min.2ca77e25.jpg";